import { getMetersTwoYearsOld } from "../../../common/api/meterReadsApi";
import { sortMpansFilterItem } from "../../../utils/sortFilters";
import { MpanFilterItem } from "../components/energyusage/types/ChartTypes";

const getRequestType = (mpan: Api.IMeter): Api.HHRequestType => {
    const { 'hh-or-nhh': hhOrNhh, 'smart-meter': smartMeter, 'meter-type': meterType } = mpan;

    var requestType: Api.HHRequestType = 'HalfHourly';

    if (hhOrNhh === 'HH') {
      requestType = 'HalfHourly';
    } else if (smartMeter === true && (meterType === 'NCAMR' || meterType === 'RCAMR' || meterType === 'RCAMY')) {
      requestType = 'AutomaticMeterRead';
    } else if (smartMeter === true && meterType.startsWith('S')) {
      requestType = 'Smart';
    }
    return requestType;
  };

const formatMpan = (mpan: Api.IMeter): MpanFilterItem => {
    const requestType = getRequestType(mpan);

    var result: MpanFilterItem = {
      mpan: `${mpan['mpan-core']}`,
      hhOrNhh: mpan['hh-or-nhh'],
      meterType: mpan['meter-type'],
      smartMeter: mpan['smart-meter'],
      requestType,
      supplyDateRemoved: mpan['supply-date-removed'],
    };
    return result;
  };
  
const groupMpans = (data: Array<Api.IMeter>) => {
    const mpans: { [key: string]: Array<Api.IMeter> } = {};

    data.map(el => {
      const mpanCore = el['mpan-core'];

      if (Object.keys(mpans).includes(mpanCore.toString())) {
        mpans[mpanCore].push(el);
      } else {
        mpans[mpanCore] = [el];
      }
      return mpans;
    });

    return mpans;
  };
  
const getMpanTime = (mpan: Api.IMeter) => new Date(mpan['configuration-end-date']).getTime();

export const loadMpans = async (authContext: any, customerId: string) => {
  let result: Array<MpanFilterItem> = [];
  const response = await getMetersTwoYearsOld(process.env.REACT_APP_API_URL, authContext, customerId);

  if (response) {
    const mpans: { [key: string]: Array<Api.IMeter> } = groupMpans(response);

    Object.keys(mpans).map(id => {
      let matchedMpan = mpans[id].find(el => el['configuration-end-date'] === null);

      if (matchedMpan) {
        result.push(formatMpan(matchedMpan));
      } else {
        const maxDateMpan = mpans[id].reduce((a, b) => (getMpanTime(a) > getMpanTime(b) ? a : b));
        result.push(formatMpan(maxDateMpan));
      }
      return result;
    });
  }

  var resultSorted = sortMpansFilterItem(result);
  return resultSorted;
};

export const canDisplayHHData = (mpanFilterItem: MpanFilterItem): boolean => {
  return (
    mpanFilterItem.hhOrNhh === 'HH' ||
    mpanFilterItem.requestType === 'AutomaticMeterRead' ||
    (mpanFilterItem.requestType === 'Smart' && mpanFilterItem.supplyDateRemoved === null)
  );
};
  
export const canDisplayHHDataFromMpans = (mpanFilterItems: MpanFilterItem[]): boolean => {
  if (mpanFilterItems.length === 0)
    return false;

  const contains = mpanFilterItems.some((mpanFilterItem: MpanFilterItem) => {
    return canDisplayHHData(mpanFilterItem);
  });
  return contains;
};

export const containsNonHHDataInMpans = (mpanFilterItems: MpanFilterItem[]): boolean => {
  if (mpanFilterItems.length === 0)
    return false;

  const contains = mpanFilterItems.some((mpanFilterItem: MpanFilterItem) => {
    const canDisplayHH = canDisplayHHData(mpanFilterItem);
    return canDisplayHH === false && true;
  });
  return contains;
};

